<div class="container">
  <div>
    <div
      class="image"
      [class.edit]="contentEdit"
      [style.background-image]="'url(' + item?.content?.img + ')'">
      @if (contentEdit) {
        <coin-v2-button
          type="secondary"
          svgIcon="edit"
          [text]="'cms.emails.change-image-button' | translate"
          (click)="editPicture()"></coin-v2-button>
      }
      @if (item?.content && contentEdit) {
        <coin-v2-text-input
          [label]="'cms.image-url' | translate"
          [(ngModel)]="item.content.link"></coin-v2-text-input>
      }
    </div>
    @if (contentEdit) {
      <coin-v2-checkbox
        class="inverse-checkbox"
        [label]="'cms.emails.inverted-checkbox' | translate"
        [(ngModel)]="item.inverted"></coin-v2-checkbox>
    }
  </div>

  <coin-html-editor
    [showAdditionalEditOptions]="showAdditionalEditOptions"
    [contentEdit]="contentEdit"
    [isContentText]="true"
    [item]="item"></coin-html-editor>
</div>
